"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const openapi_1 = __importDefault(require("@graphql-mesh/openapi"));
const BASE_URL = 'https://slack.com/api';
class SlackHandler extends openapi_1.default {
    constructor({ name, config, cache, pubsub, }) {
        config.source = require.resolve('@graphql-portal/slack/src/source.json');
        config.baseUrl = BASE_URL;
        config.operationHeaders = {
            authorization: `Bearer ${config.token}`,
        };
        super({ name, config, cache, pubsub });
    }
}
exports.default = SlackHandler;
//# sourceMappingURL=handler.js.map